<template>
    <div v-if="isVisible" class="form-item">
        <Question :item="item" />
    </div>
</template>

<script>
import Question from "../components/Question.vue";

import logicMixin from "../mixins/logic";

export default {
    name: 'Instruction',
    components: { Question },
    mixins: [ logicMixin ],
    props: {
        item: {
            type: Object
        }
    }
};
</script>